import { React } from 'Imports';
import { useLayoutEffect, useRef, useState } from 'react';

interface TruncatedTextProps {
    className?: string;
    children: string;
}

// Measures whether the rendered box is actually clipping its own text (scrollWidth > clientWidth)
// instead of guessing from a character-count threshold. That keeps the tooltip correct regardless of
// how wide/large a given caller's own CSS makes the box -- callers stay responsible for the ellipsis
// styling (white-space: nowrap; overflow: hidden; text-overflow: ellipsis); this only reports on it.
export const TruncatedText = ({ className, children }: TruncatedTextProps) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useLayoutEffect(() => {
        const el = ref.current;
        setIsTruncated(!!el && el.scrollWidth > el.clientWidth);
    }, [children, className]);

    return (
        <div ref={ref} className={className} title={isTruncated ? children : undefined}>
            {children}
        </div>
    );
};
